import { z } from 'zod';

const num = () => z.coerce.number();
const numNull = () => z.union([z.coerce.number(), z.null()]);

/* Depth targets (goalpost.store_brand_depth_target via
   stg_supabase_store_brand_depth_target), active rows, with brand manager and merch portfolio. */
export const DepthBreadthTargetsSchema = z.array(
  z.object({
    store: z.string(),
    brand_name: z.string(),
    effective_from: z.string(),
    depth_per_style: numNull(),
    count_of_sizes: numNull(),
    brand_manager: z.string().nullable(),
    merch_portfolio: z.string().nullable(),
  }),
);
export type DepthBreadthTargets = z.infer<typeof DepthBreadthTargetsSchema>;

/* GPO codes arrive comma-joined (the card flattens the array); '' = none. */
const gpoCodes = () =>
  z
    .string()
    .nullable()
    .transform(s => (s ? s.split(',').filter(Boolean) : []));

/* On hand (styles, total_units, size_count_sum) plus on hand + incoming on open
   GPOs (stale lines excluded), incoming units and the distinct GPO codes. */
const depthRow = {
  date: z.string(),
  facility_name: z.string(),
  brand_name: z.string(),
  styles: num(),
  total_units: num(),
  size_count_sum: num(),
  styles_with_incoming: num(),
  total_units_with_incoming: num(),
  size_count_sum_with_incoming: num(),
  incoming_units: num(),
  gpo_codes: gpoCodes(),
};

/* mart_store_brand_depth_daily for one facility and date range. */
export const DepthBreadthDailySchema = z.array(z.object(depthRow));
export type DepthBreadthDaily = z.infer<typeof DepthBreadthDailySchema>;

/* Today's live depth rows (mart_latest_warehouse_inventory + open GPOs in
   mart_gatepass_item) for one facility; updated_at = latest inventory change in
   the facility, same on every row. */
export const DepthBreadthLiveSchema = z.array(
  z.object({ ...depthRow, updated_at: z.string().nullable() }),
);
export type DepthBreadthLive = z.infer<typeof DepthBreadthLiveSchema>;

export const DepthBreadthBrandOptionsSchema = z.array(z.object({ brand_name: z.string() }));
export type DepthBreadthBrandOptions = z.infer<typeof DepthBreadthBrandOptionsSchema>;
